<template>
  <div class="container">
    <ResultsTable/>
    <BannerCat/>
  </div>
</template>

<script>
import ResultsTable from '@/components/ResultsTable';
import BannerCat from '@/components/BannerCat';

export default {
  name: 'Winners',
  components: {
    ResultsTable,
    BannerCat,
  },
};
</script>

<style scoped lang="scss">
.container {
  @media (max-width: 1023px) {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
